import { Event } from './Event';

export type ScheduleState = {
    events: Event[];
    dialog: {
        isReference: boolean;
        data: Event | null;
    }
}

export const INITIAL_STATE: ScheduleState = {
    events: [],
    dialog: {
        isReference: false,
        data: null
    }
}

export * from './Event';
